import {Component, OnInit} from '@angular/core';
import {ClientConfigurationService} from '@twpub/core/services';
import {NGXLogger} from 'ngx-logger';
import {
  MatCard,
  MatCardActions,
  MatCardAvatar,
  MatCardContent,
  MatCardHeader,
  MatCardTitle
} from '@angular/material/card';
import {TermwebStatusTextComponent} from '../termweb-status-text/termweb-status-text.component';

import {MatAnchor} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'pub-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss'],
  standalone: true,
  imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, TermwebStatusTextComponent, MatAnchor, RouterLink, MatIcon, MatCardAvatar, MatCardActions]
})
export class AdminHomeComponent implements OnInit {
  isConfigurationOk: boolean = false;

  constructor(private logger: NGXLogger, private configService: ClientConfigurationService) {
  }

  ngOnInit(): void {
    this.logger.debug('AdminHomeComponent.ngOnInit');
    this.checkTermWebConfiguration();
  }

  private checkTermWebConfiguration() {
    this.configService.hasTermWebConfiguration().subscribe({
      next: () => {
        this.isConfigurationOk = true;
      },
      error: () => {
        this.isConfigurationOk = false;
      }
    });
  }
}
